module.exports = __webpack_public_path__ + "9b6bf6846394468d45c01af0f11a2e9f.svg";